module.exports = __webpack_public_path__ + "static/media/data.a29f8e38.svg";